import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import { sortBy } from 'lodash/fp';

export const ACCOUNT_GET_MESSAGES = graphql(`
  query AccountGetMessages($otherAccountId: Int!) {
    messages(otherAccountId: $otherAccountId) {
      id
      seen
      seenAt
      img
      file
      content
      reported
      fromAccountId
      toAccountId
      createdAt
    }
  }
`);

export const useGetMessages = (otherAccountId?: number) => {
  const { data, error, loading, startPolling, stopPolling } = useQuery(ACCOUNT_GET_MESSAGES, {
    variables: {
      otherAccountId: otherAccountId!,
    },
    skip: !otherAccountId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  });

  return {
    messages: sortBy((x) => x.createdAt, data?.messages ?? []),
    messagesError: error,
    messagesLoading: loading,
    messagesStartPoll: startPolling,
    messagesStopPoll: stopPolling,
  };
};
